import { useState, useEffect, useCallback } from "react";
import { ActionPlansContainer } from "../Container";
import { NameCard } from "../NameCard";
import GridLayout from "../EffortsList";
import "../../components/ActionPlans/LogisticDepartment/index.css";
import "../../index.css";
import "./index.css";
import deptIcon from "../../../../assets/shapes_svg/ambition/actionplans/purchasing-icon.svg";
import lineBreak from "../../../../assets/shapes_svg/ambition/Line_Break.svg";
import { WriteEffort } from "../WriteEffort";
import SuccessCriteria from "../SuccessCriteria";
import Assumptions from "../Assumptions";
import Themes from "../Themes";
import TimelineComponent from "../Timeline";
import TeamSection from "../TeamSelections";
import FollowUpSection from "../FollowUpSections";
import { LinksSection } from "../LinkSection";
import { Investments } from "../Investments";
import {
  createEffort,
  getEfforts,
} from "../../../../apis/Business/DepartmentEffortApi";
import { useInvalidateQuery } from "../../../../components/InvalidateQueryContext";
import { ambitionDeptKey } from "../../../../apis/ApiKey/AmbitionDepartmentKey";
import { useParams } from "react-router-dom";
import Feedback from "../Feedback";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const LogisticActionPlans = () => {
  const [newEffort, setNewEffort] = useState("");
  const [chosenEffort, setChosenEffort] = useState(null);
  const [efforts, setEfforts] = useState([]);
  const { triggerInvalidate, invalidateKey, resetKey } = useInvalidateQuery();
  const { createEfforts, updateEfforts } = ambitionDeptKey;
  const { departmentId, year } = useParams();

  const renderItem = (item) => (
    <div
      className={`logistic-action-item ${
        chosenEffort?.id === item.id ? "active-chosen-effort" : ""
      }`}
      onClick={() => setChosenEffort(item)}
    >
      <h4>{item.name}</h4>
    </div>
  );
  useEffect(() => {
    fetchEfforts();
  }, [departmentId]);

  const fetchEfforts = useCallback(async () => {
    try {
      const fetchedEfforts = await getEfforts(departmentId);
      setEfforts(fetchedEfforts);
      // Auto-select the first effort if none is selected
      if (fetchedEfforts.length > 0 && !chosenEffort) {
        setChosenEffort(fetchedEfforts[0]);
      }
    } catch (err) {
      console.error("Failed to fetch efforts:", err);
    }
  }, [departmentId]);

  const handleSaveEffort = async () => {
    if (newEffort.trim()) {
      try {
        await createEffort({
          departmentId: departmentId,
          name: newEffort.trim(),
          triggerInvalidate: triggerInvalidate,
        });
        fetchEfforts();
        setNewEffort("");
      } catch (error) {
        console.error("Failed to create effort:", error);
      }
    }
  };

  useEffect(() => {
    if (invalidateKey === createEfforts || invalidateKey === updateEfforts) {
      fetchEfforts();
    }
    resetKey();
  }, [createEfforts, updateEfforts, fetchEfforts, invalidateKey, resetKey]);
  return (
    <ActionPlansContainer>
      <div
        style={{
          display: "flex",
          gap: "15px",
          marginTop: "48px",
        }}
      >
        <NameCard
          className={"logistic"}
          isBottom={true}
          deptIcon={deptIcon}
          deptName={"Logistic"}
        />
        <GridLayout
          containerClassName="logistic"
          items={efforts}
          renderItem={renderItem}
          className={"logistic-action-item"}
          newName={newEffort}
          setNewName={setNewEffort}
          handleSave={handleSaveEffort}
        />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          marginBottom: "48px",
        }}
      >
        <img src={lineBreak} alt="Line Break" height={3} />
      </div>
      <WriteEffort
        effortName={"Effort"}
        question={chosenEffort ? chosenEffort.name : "Effort Name"}
        effortId={chosenEffort?.id}
        departmentId={departmentId}
        description={chosenEffort?.description}
      />
      {year && <SuccessCriteria year={year} effortId={chosenEffort?.id} />}
      <TeamSection effortId={chosenEffort?.id} year={year} />
      <Assumptions effortId={chosenEffort?.id} />
      <Themes effortId={chosenEffort?.id} />
      <TimelineComponent effortId={chosenEffort?.id} />

      <FollowUpSection effortId={chosenEffort?.id} />
      <DndProvider backend={HTML5Backend}>
        <div>
          <Investments effortId={chosenEffort?.id} />
          <Feedback effortId={chosenEffort?.id} />
        </div>
      </DndProvider>

      <LinksSection effortId={chosenEffort?.id} />
    </ActionPlansContainer>
  );
};

export default LogisticActionPlans;
